import { emission_factor_type_enum } from '@predium/enums';
import { ReactNode } from 'react';
import { CrremOrgPreferences, OrgPreferences } from '../../../contexts/OrgPreferences/OrgPreferencesContext';
import useOrgPreferences from '../../../hooks/useOrgPreferences';

export function hasValidCrremConfig(orgPreferences: OrgPreferences): orgPreferences is CrremOrgPreferences {
  return (
    orgPreferences.emissionFactorType === emission_factor_type_enum.CRREM &&
    Array.isArray(orgPreferences.crremConfigurations) &&
    orgPreferences.crremConfigurations.length > 0 &&
    !!orgPreferences.activeCRREMConfiguration
  );
}

export function CrremGuard({ children }: { children: (orgPreferences: CrremOrgPreferences) => ReactNode }) {
  const { orgPreferences } = useOrgPreferences();
  if (hasValidCrremConfig(orgPreferences)) {
    return <>{children(orgPreferences)}</>;
  }
  return null;
}
